import React, { useState } from "react";
import { getAllRoleIds } from "./Services/EnterUserSer";

import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import axios from "axios";
const EnterUsers = () => {
  useEffect(() => {
    const scriptUrls = [
      'assets/js/jquery.min.js',
      'assets/js/bootstrap.bundle.min.js',
      'assets/js/moment.min.js',
      'assets/vendor/overlay-scroll/jquery.overlayScrollbars.min.js',
      'assets/vendor/overlay-scroll/custom-scrollbar.js',
      'assets/vendor/daterange/daterange.js',
      'assets/vendor/daterange/custom-daterange.js',
      'assets/vendor/jquery-ui/jquery-ui.min.js',
      'assets/vendor/jquery-ui/custom.js',
      'assets/vendor/datatables/dataTables.min.js',
      'assets/vendor/datatables/dataTables.bootstrap.min.js',
      'assets/vendor/datatables/custom/custom-datatables.js',
      'assets/js/custom.js'
    ];

    let isCancelled = false;

    // Load scripts sequentially
    const loadScriptsSequentially = async () => {
      for (const url of scriptUrls) {
        if (isCancelled) break;

        await new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = url;
          script.onload = resolve;
          script.onerror = reject;
          document.body.appendChild(script);
        });
      }
    };

    loadScriptsSequentially();

    return () => {
      isCancelled = true;
      // Optionally remove scripts if needed
    };
  }, []);
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [phone, setPhone] = useState('');
  const [address, setAddress] = useState('');
  const [gender, setGender] = useState('');
  const [dob, setDob] = useState('');
  const [alternativePhone, setAlternativePhone] = useState('');
  const [qualification, setQualification] = useState('');
  const [bloodGroup, setBloodGroup] = useState('');
  const [maritalStatus, setMaritalStatus] = useState('');
  const [company, setCompany] = useState('');

  const [role, setRole] = useState('');
  const [roleIds, setRoleIds] = useState([]);
  const [Age, setAge] = useState('')
  const [departmentName, setDepName] = useState('');
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [departments, setDepartments] = useState([]);
  const [department, setDepartment] = useState(""); // for selected department
  const [designations, setDesignations] = useState([]);
  // const [designation, setDesignation] = useState('');

  const [selectedDesignationId, setSelectedDesignationId] = useState("");
  const [userTypes, setUserTypes] = useState([]);
  const [selectedUserTypeId, setSelectedUserTypeId] = useState("");



  const navigator = useNavigate();
  useEffect(() => {
    getAllRoleIds()
      .then((res) => {
        console.log("Fetched role IDs:", res.data);
        setRoleIds(res.data);
      })
      .catch((err) => {
        console.error("Error fetching role IDs:", err);
      });
  }, []);
  const handleEnter = (e) => {
    e.preventDefault();

    const parsedDesignation = selectedDesignationId ? parseInt(selectedDesignationId) : null;
    const parsedUserTypeId = selectedUserTypeId ? parseInt(selectedUserTypeId) : null;
    console.log("Parsed Designation ID:", selectedUserTypeId);
    console.log("Parsed User Type ID:", parsedUserTypeId);
    // Prepare the data as a JSON object
    console.log("Parsed Designation:", role);

    const userData = {
      firstName: firstName,
      lastName: lastName,
      email: email,
      password: password,
      phone: phone,
      address: address,
      gender: gender,
      dob: dob,
      rolesId: parseInt(role),
      userTypeId: parsedUserTypeId ,
      qualification: qualification,
      bloodGroup: bloodGroup,
      maritalStatus: maritalStatus,
      alternativePhone: alternativePhone,
      designationId: parsedDesignation,
      departmentId: parseInt(department),
      age: parseInt(Age)

    };
    console.log("first", userData.firstName, "lastName", userData.lastName, userData.email, userData.password, userData.phone, userData.address, userData.gender, userData.dob, "rolesId", userData.rolesId, userData.qualification, userData.bloodGroup, userData.maritalStatus, userData.alternativePhone, userData.designationId, userData.departmentId);
    console.log("Designation state before submit:", parsedDesignation, userData.userTypes);

    const EnterUserSer = (userData) => {
      return axios.post('http://localhost:8080/webnet-hms/api/users', userData); // check if URL is correct
    };
    // Use EnterUserSer to send the data to the backend
    EnterUserSer(userData)
      .then((response) => {
        console.log("done");
        console.log("User created successfully:", response.data);
        alert("User Created Succesfully");
        navigator("/admin-view");
        window.location.reload();
      })
      .catch((error) => {
        console.error("Error creating user:", error.response?.data || error.message);
        alert("Error creating user: " + (error.response?.data?.message || error.message));

      });
  };
  const toSentenceCase = (str) => {
    if (!str) return '';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  };
  const handleDateChange = (e) => {
    const isoDate = e.target.value; // "2025-04-25"
    const [year, month, day] = isoDate.split("-");
    const formatted = `${day}/${month}/${year}`; // "25/04/2025"
    setDob(formatted); // now dob is in the format backend expects
  };


  const navigators = useNavigate();
  // for filling up the department dropdown 
  useEffect(() => {
    const REST_API_BASE_URL = `http://localhost:8080/webnet-hms/api/department`;
    const Departments = () => axios.get(REST_API_BASE_URL);
    Departments().then((response) => {
      const departmentData = response.data;
      setDepartments(departmentData);

    }).catch(error => {
      window.alert(error + " ");

    })
  }, [])

  useEffect(() => {
    const REST_API_BASE_URL = `http://localhost:8080/webnet-hms/api/designation`;
    const Designations = () => axios.get(REST_API_BASE_URL);
    Designations().then((response) => {
      const designationData = response.data;
      setDesignations(designationData);
    }).catch(error => {
      window.alert(error + " ");

    })
  }, [])

  useEffect(() => {
    // Fetch user types from backend
    axios.get('http://localhost:8080/webnet-hms/api/user-types') // Replace with your actual API
      .then((response) => setUserTypes(response.data))
      .catch((error) => console.error('Error fetching user types:', error));
  }, []);


  const changeAge = (e) => {
    setAge(e.target.value);
  }

  return (


    <div>
      {/* App hero header starts */}
      <div className="app-hero-header d-flex align-items-center">
        {/* Breadcrumb starts */}
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a href="index-2.html">
              <i className="ri-home-3-line" />
            </a>
          </li>
          <li className="breadcrumb-item">User</li>
          <li className="breadcrumb-item text-primary" aria-current="page">
            Add User
          </li>
        </ol>
        {/* Breadcrumb ends */}
        {/* Sales stats starts */}
        <div className="ms-auto d-lg-flex d-none flex-row">
          <div className="input-group">
            <span className="input-group-text bg-primary-lighten">
              <i className="ri-calendar-2-line text-primary" />
            </span>
            <input type="text" id="abc" className="form-control custom-daterange" />
          </div>
        </div>
        {/* Sales stats ends */}
      </div>
      {/* App Hero header ends */}
      {/* App body starts */}
      <div className="app-body">
        {/* Row starts */}
        <div className="row gx-4">
          <div className="col-sm-12">
            <div className="card">
              <div className="card-header">
                <h5 className="card-title">Add User</h5>
              </div>
              <div className="card-body">
                {/* Row starts */}
                <div className="row gx-4">
                  <div className="col-sm-12">
                    <div className="bg-light rounded-2 px-3 py-2 mb-3">
                      <h6 className="m-0">Personal Details</h6>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-lg-4 col-sm-6">
                    <div className="mb-3">
                      <label className="form-label" htmlFor="a1">First Name <span className="text-danger">*</span></label>
                      <input type="text" className="form-control" id="a1" placeholder="Enter First Name" name="first_name" required onChange={(e) => setFirstName(e.target.value)} />
                    </div>
                  </div>
                  <div className="col-xxl-3 col-lg-4 col-sm-6">
                    <div className="mb-3">
                      <label className="form-label" htmlFor="a2">Last Name <span className="text-danger">*</span></label>
                      <input type="text" className="form-control" id="a2" placeholder="Enter Last Name" name="last_name" required onChange={(e) => setLastName(e.target.value)} />
                    </div>
                  </div>
                  <div className="col-xxl-3 col-lg-4 col-sm-6">
                    <div className="mb-3">

                      <label className="form-label" htmlFor="a6">Roles<span className="text-danger">*</span></label>
                      <select className="form-select" id="a6" required onChange={(e) => setRole(e.target.value)}>
                        {roleIds.map(roleId => (
                          <option key={roleId.roleId} value={roleId.rolesId}>
                            {toSentenceCase(roleId.roleName)}</option>
                        ))}

                      </select>

                    </div>
                  </div>
                  <div className=" col-xxl-3 col-lg-4 col-sm-6">
                    <div className="mb-3">
                      <label className="form-label" htmlFor="a3">Age <span className="text-danger">*</span></label>
                      <div className="input-group">

                        <select className="form-select" id="a3" onChange={(e) => setAge(e.target.value)}>
                          <option value="">Select Age</option>
                          {Array.from({ length: 100 }, (_, i) => (
                            <option key={i + 1} value={i + 1}>
                              {i + 1}
                            </option>
                          ))}

                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-lg-4 col-sm-6">
                    <div className="mb-3">
                      <label className="form-label" htmlFor="selectGender1">Gender <span className="text-danger">*</span></label>
                      <div className="m-0">
                        <div className="form-check form-check-inline">

                          <input className="form-check-input" type="radio" name="gender" id="selectGender1" defaultValue="MALE" value={gender} onChange={(e) => setGender(e.target.value)} />

                          <label className="form-check-label" htmlFor="selectGender1">Male</label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input className="form-check-input" type="radio" name="gender" id="selectGender2" defaultValue="FEMALE" onChange={(e) => setGender(e.target.value)} />
                          <label className="form-check-label" htmlFor="selectGender2">Female</label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-lg-4 col-sm-6">
                    <div className="mb-3">
                      <label className="form-label" htmlFor="a4">Date of Birth <span className="text-danger">*</span></label>

                      <input type="date" className="form-control" id="a4" name="dob" onChange={handleDateChange} />


                    </div>
                  </div>
                  <div className="col-xxl-3 col-lg-4 col-sm-6">
                    <div className="mb-3">
                      <label className="form-label" htmlFor="a3">Mobile Number<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" id="a3" placeholder="Enter Mobile Number" name="phone" required onChange={(e) => setPhone(e.target.value)} />
                    </div>
                  </div>
                  <div className="col-xxl-3 col-lg-4 col-sm-6">
                    <div className="mb-3">
                      <label className="form-label" htmlFor="a6"> Alternate Mobile Number <span className="text-danger">*</span></label>
                      <div className="input-group">


                        <input
                          type="text"
                          className="form-control"
                          id="a6"
                          placeholder="Enter Alternate Mobile Number"
                          value={alternativePhone}
                          onChange={(e) => setAlternativePhone(e.target.value)}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-xxl-3 col-lg-4 col-sm-6">
                    <div className="mb-3">
                      <label className="form-label" htmlFor="a7">Email <span className="text-danger">*</span></label>
                      <input type="email" className="form-control" id="a7" placeholder="abc@gmail.com" required onChange={(e) => setEmail(e.target.value)} />
                    </div>
                  </div>
                  <div className="col-xxl-3 col-lg-4 col-sm-6">
                    <div className="mb-3">
                      <label className="form-label" htmlFor="a8">Qualification</label>
                      <div className="input-group">
                        {/* <span className="input-group-text">
                          <i className="ri-copper-diamond-line" />
                        </span> */}

                        <select
                          className="form-select"
                          id="a8"
                          value={qualification}
                          onChange={(e) => setQualification(e.target.value)}
                        >
                          <option value="MSc.">MSc.</option>
                          <option value="BSc.">BSc.</option>
                        </select>


                      </div>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-lg-4 col-sm-6">
                    <div className="mb-3">
                      <label className="form-label" htmlFor="a10">Blood Group<span className="text-danger">*</span></label>
                      <div className="input-group">
                        {/* <span className="input-group-text">
                          <i className="ri-drop-line" />
                        </span> */}

                        <select
                          className="form-select"
                          id="a10"
                          value={bloodGroup}
                          onChange={(e) => setBloodGroup(e.target.value)}
                        >
                          <option value="O+">O+</option>
                          <option value="A+">A+</option>
                          <option value="A-">A-</option>
                          <option value="B+">B+</option>
                          <option value="B-">B-</option>
                          <option value="O-">O-</option>
                          <option value="AB+">AB+</option>
                          <option value="AB-">AB-</option>
                        </select>


                      </div>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-lg-4 col-sm-6">
                    <div className="mb-3">
                      <label className="form-label" htmlFor="a7">Marital Status</label>
                      <div className="input-group">
                        {/* <span className="input-group-text">
                          <i className="ri-vip-crown-2-line" />
                        </span> */}

                        <select
                          className="form-select"
                          id="a7"
                          value={maritalStatus}
                          onChange={(e) => setMaritalStatus(e.target.value)}
                        >
                          <option value="Married">MARRIED</option>
                          <option value="Unmarried">UNMARRIED</option>
                        </select>


                      </div>
                    </div>
                  </div>

                  <div className="col-sm-4">
                    <label className="form-label" htmlFor="a1">Department</label>
                    <select
                      className="form-select"
                      id="a1"
                      onChange={(e) => setDepartment(e.target.value)}
                      value={department}
                    >
                      <option value="">Select</option>
                      {departments.length > 0 ? (
                        departments.map((dept) => (
                          <option key={dept.departmentId} value={dept.departmentId}>
                            {dept.departmentName}
                          </option>
                        ))
                      ) : (
                        <option value="">No departments available</option>
                      )}
                    </select>
                  </div>
                  <div className="col-xxl-3 col-lg-4 col-sm-6">
                    <div className="mb-3">
                      <label className="form-label" htmlFor="a9">Designation</label>
                      <div className="input-group">
                        {/* <span className="input-group-text">
                                <i className="ri-nft-line" />
                              </span> */}
                        <select
                          className="form-select"
                          id="designationSelect"
                          value={selectedDesignationId}
                          onChange={(e) => {
                            const selectedId = e.target.value;
                            setSelectedDesignationId(selectedId);
                            console.log('Selected Designation ID:', selectedId);  // Logs the ID
                          }}
                        >
                          <option value="">Select Designation</option>
                          {designations.map((des) => (
                            <option key={des.desigantionId} value={des.desigantionId}>
                              {des.designation}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-lg-4 col-sm-6">
                    <div className="mb-3">
                      <label className="form-label" htmlFor="a9">UserTypes</label>


                      <select
                        className="form-select"
                        id="userType"
                        value={selectedUserTypeId}
                        onChange={(e) => {
                          console.log("Selected UserType ID (string):", e.target.value);
                          setSelectedUserTypeId(e.target.value);
                        }}
                        required
                      >
                        <option value="">Select User Type</option>
                        {userTypes.map((type) => (
                          <option key={type.userTypeId} value={type.userTypeId}>
                            {type.userTypeName}
                          </option>
                        ))}
                      </select>

                    </div>

                  </div>

                  <div className="col-sm-12">
                    <div className="mb-3">
                      <label className="form-label" htmlFor="a8">Address <span className="text-danger">*</span></label>
                      <textarea className="form-control" id="a8" placeholder="Enter Address" rows={2} defaultValue={""} onChange={(e) => setAddress(e.target.value)} required />
                    </div>
                  </div>

                  <div className="col-sm-12">
                    <div className="d-flex gap-2 justify-content-end">
                      <a href="#!" className="btn btn-outline-secondary">
                        Cancel
                      </a>

                      <button type="submit" className="btn btn-primary" onClick={() => setShowPasswordModal(true)}>

                        Add User
                      </button>
                    </div>
                  </div>
                </div>
                {/* Row ends */}

                {showPasswordModal && (
                  <div className="modal d-block" tabIndex="-1" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
                    <div className="modal-dialog">
                      <div className="modal-content">
                        <div className="modal-header">
                          <h5 className="modal-title">Set Password</h5>
                          <button type="button" className="btn-close" onClick={() => setShowPasswordModal(false)}></button>
                        </div>
                        <div className="modal-body">
                          <input
                            type="password"
                            className="form-control"
                            placeholder="Enter password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                          />
                        </div>
                        <div className="modal-footer">
                          <button type="button" className="btn btn-secondary" onClick={() => setShowPasswordModal(false)}>
                            Close
                          </button>
                          <button type="button" className="btn btn-primary" onClick={handleEnter}>
                            Save
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}



              </div>
            </div>
          </div>
        </div>
        {/* Row ends */}
      </div>
    </div>

  );
}
export default EnterUsers;
